__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.50.12-a2b5-amber-user-website-prod-hk-1785/assets/";